
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/piskotki",
      function () {
        return require("private-next-pages/piskotki.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/piskotki"])
      });
    }
  